import React from 'react';
import { VEHICLE_TYPES } from '../data/services';
import { ServiceIcon } from './icons';

// vehicleTypes prop 미지정 시 전체(자동차+오토바이). 카테고리별 분리 호출 시 좁힌 배열 전달.

function fmt(price) {
  if (!price || price <= 0) return '문의';
  return '₩' + price.toLocaleString();
}

const thStyle = {
  padding: '12px 16px', textAlign: 'left',
  fontSize: '0.9rem', color: 'var(--text-muted)', fontWeight: 600,
};

const tdStyle = {
  padding: '12px 16px', fontSize: '0.95rem',
};

export default function PriceTable({ service, vehicleTypes = VEHICLE_TYPES }) {
  return (
    <div style={{ marginBottom: 32 }}>
      <h3 style={{
        fontSize: '1.2rem', fontWeight: 600, marginBottom: 16,
        display: 'flex', alignItems: 'center', gap: 8,
      }}>
        <ServiceIcon serviceId={service.id || service.serviceId} fallbackIcon={service.icon} size={22} style={{ color: 'var(--primary)' }} /> {service.name}
      </h3>

      {/* Desktop table */}
      <table className="price-table-desktop" style={{
        width: '100%', borderCollapse: 'collapse',
        background: 'var(--surface)', borderRadius: 'var(--radius)',
        overflow: 'hidden',
      }}>
        <thead>
          <tr style={{ background: 'var(--surface-elev)' }}>
            <th style={thStyle}>차종</th>
            <th style={thStyle}>예시</th>
            <th style={thStyle}>가격</th>
          </tr>
        </thead>
        <tbody>
          {vehicleTypes.map(v => (
            <tr key={v.id} style={{ borderBottom: '1px solid var(--border)' }}>
              <td style={tdStyle}>{v.name}</td>
              <td style={{ ...tdStyle, color: 'var(--text-muted)' }}>{v.example}</td>
              <td style={{ ...tdStyle, color: 'var(--primary)', fontWeight: 600 }}>
                {fmt(service.prices[v.id])}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile cards */}
      <div className="price-table-mobile" style={{ display: 'none' }}>
        {VEHICLE_TYPES.map(v => (
          <div key={v.id} style={{
            display: 'flex', justifyContent: 'space-between',
            padding: '12px 16px', background: 'var(--surface)',
            borderBottom: '1px solid var(--border)',
          }}>
            <div>
              <span style={{ fontWeight: 600 }}>{v.name}</span>
              <span style={{ color: 'var(--text-dim)', fontSize: '0.85rem', marginLeft: 8 }}>
                {v.example}
              </span>
            </div>
            <span style={{ color: 'var(--primary)', fontWeight: 600 }}>
              {fmt(service.prices[v.id])}
            </span>
          </div>
        ))}
      </div>

      <style>{`
        @media (max-width: 768px) {
          .price-table-desktop { display: none !important; }
          .price-table-mobile { display: block !important; }
        }
      `}</style>
    </div>
  );
}
